import styles from './style.module.scss';
import { RoadmapTimeLine } from './roadmap-time-line';
import { IJsonConfig } from '../../model/products';
import { getLocaleLanguage, LanguageType } from '../../lib';
import { useEffect, useState } from 'react';
import getFormatMessage from '../../locales/get-format-message';
import { getConfig } from '../../config';
import { LayoutDefault } from '../../router/templates/default';
import { RoadmapContentItem } from './roadmap-content-item';
import { AppEnvType } from '../../model';
import classNames from 'classnames';
import downActiveIcon from '../../assets/svg/down-icon-active.svg';
import topIcon from '../../assets/svg/time-line-top.svg';
import { RoadmapTimeLineMobile } from './roadmap-time-line-mobile';

export const RoadmapComponent = () => {
  const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US;
  const [configData, setConfigData] = useState<IJsonConfig | null>(null);
  const [classifyList, setClassifyList] = useState<string[]>([]);
  const [selectTimeKey, setSelectTimeKey] = useState<string>('');
  const [activeItem, setActiveItem] = useState<number>(0);
  const [isFixed, setIsFixed] = useState<boolean>(false);
  const consoleURL = getConfig()?.consoleURL;

  useEffect(() => {
    init();
    const box = document.getElementById('roadmapTimeLineMobileBox');
    if (!box) return;
    const onScroll = () => {
      // 获取元素相对于视口顶部的距离
      const rect = box.getBoundingClientRect();
      const distanceFromTop = rect.top; // 元素顶部到视口顶部的距离
  
      // 如果距离 <= 120px，添加类；否则移除类
      if (distanceFromTop <= 120) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    }
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    }
  }, []);

  const init = async () => {
    let currentConfigData = configData;
    const appConfig = getConfig();
    const configUrl = appConfig.cdnURL
      ? `${appConfig.cdnURL}/ingame-website/app-config/${
          appConfig.env === AppEnvType.Production
            ? 'prod-config'
            : 'test-config'
        }/${currentStoreLanguage}.json`
      : '';
    if (!currentConfigData) {
      try {
        const response = await fetch(configUrl);
        if (!response.ok) {
          return console.log('error');
        }
        const data = await response.json(); // 解析JSON格式的响应体
        if (data) {
          setConfigData(data);
          currentConfigData = data;
        }
      } catch (error) {
        console.error('There was a problem with your fetch operation:', error);
      }
    }
    const currentClassifyList = currentConfigData?.roadmapConfig
      ? Object.keys(currentConfigData.roadmapConfig)
      : [];
    setClassifyList(currentClassifyList);
    setSelectTimeKey(
      currentClassifyList.length !== 0 ? currentClassifyList[0] : ''
    );
  };

  const handleVersionDocumentationClick = () => {
    if (consoleURL) {
      const url = `${consoleURL}${
        currentStoreLanguage === LanguageType.zh_CN
          ? '/doc/detail/36/1264'
          : '/doc/detail/35/1265'
      }`;
      window.open(url, '_blank');
    }
  };

  const renderContent = () => {
    if (!configData) {
      return null;
    }
    return (
      <div>
        <div
          className={classNames(
            styles.roadmapContentBox,
            styles.roadmapContentBoxOne
          )}
        >
          <div className={styles.roadmapLeftBox}>
            {configData?.roadmapConfig[selectTimeKey] &&
              configData?.roadmapConfig[selectTimeKey].length !== 0 &&
              configData?.roadmapConfig[selectTimeKey].map((item, index) => {
                return <RoadmapContentItem data={item} active={index === activeItem} activeChange={() => setActiveItem(index)} />;
              })}
          </div>
        </div>
        <div
          className={classNames(
            styles.roadmapContentBox,
            styles.roadmapContentBoxTwo
          )}
        >
          <div style={{ columnCount: 2, columnGap: '32px' }}>
            {configData?.roadmapConfig[selectTimeKey] &&
              configData?.roadmapConfig[selectTimeKey].length !== 0 &&
              configData?.roadmapConfig[selectTimeKey].map((item) => {
                return <RoadmapContentItem data={item} />;
              })}
          </div>
          {/* <div className={styles.roadmapLeftBox}>
            {configData?.roadmapConfig[selectTimeKey] &&
              configData?.roadmapConfig[selectTimeKey].length !== 0 &&
              configData?.roadmapConfig[selectTimeKey].map((item, index) => {
                if (index % 2 === 0) {
                  return <RoadmapContentItem data={item} />;
                }
                return null;
              })}
          </div>
          <div className={styles.roadmapLeftBox}>
            {configData?.roadmapConfig[selectTimeKey] &&
              configData?.roadmapConfig[selectTimeKey].length !== 0 &&
              configData?.roadmapConfig[selectTimeKey].map((item, index) => {
                if (index % 2 === 0) {
                  return null;
                }
                return <RoadmapContentItem data={item} />;
              })}
          </div> */}
        </div>
      </div>
    );
  };
  return (
    <LayoutDefault>
      <>
        <div className={styles.roadmapBox}>
          <img src={topIcon} className={styles.moboleTopIcon} />
          <div className={styles.roadmapHeaderBox}>
            <div className={styles.roadmapHeaderSecond}>
              <span>{getFormatMessage('roadmap_title_second')}</span>
            </div>
            <div className={styles.roadmapHeaderFirst}>
              {getFormatMessage('roadmap_title_first')}
            </div>
            <div
              className={styles.roadmapHeaderVersion}
              onClick={handleVersionDocumentationClick}
            >
              {getFormatMessage('roadmap_version')}
              <img
                src={downActiveIcon}
                className={styles.roadmapHeaderVersionIcon}
              />
            </div>
          </div>
          <RoadmapTimeLineMobile
            selectTimeKey={selectTimeKey}
            setSelectTimeKey={setSelectTimeKey}
            classifyList={classifyList}
            setActiveItem={setActiveItem}
            isFixed={isFixed}
          />
          <div className={styles.roadmapBodyBox}>
            <RoadmapTimeLine
              selectTimeKey={selectTimeKey}
              setSelectTimeKey={setSelectTimeKey}
              classifyList={classifyList}
            />
            {renderContent()}
          </div>
        </div>
      </>
    </LayoutDefault>
  );
};
